import { ref } from "vue";
import {roles} from "@/router/permissions/accessRoles";

const menuItemsStatic = [
  {
    label: "Início",
    icon: "home",
    active: true,
    to: "/",
    name: "home",
    componentName: "views/HomeView.vue",
    meta: { requiresAuth: true },
  },
  {
    label: "Menus",
    icon: "list",
    active: false,
    to: "/paginas",
    submenu: [
      {
        label: "Listagem Menus",
        active: false,
        to: "/paginas",
        // to: "/paginas",
        // name: "paginas.index",
        componentName: "views/paginas/paginas/ListaPaginas.vue",
      },
      {
        label: "Ordenação Superior",
        active: false,
        to: "/configuracao-menus-superior",
        componentName: "views/paginas/configuracaoMenus/ConfiguracaoMenuSuperior.vue",
      },
      {
        label: "Ordenação Meio",
        active: false,
        to: "/configuracao-menus-meio",
        componentName: "views/paginas/configuracaoMenus/ConfiguracaoMenus.vue",
      },
      {
        label: "Ordenação Sub Superior",
        active: false,
        to: "/configuracao-menus-subsuperior",
        componentName: "views/paginas/configuracaoMenus/ConfiguracaoMenuSubSuperior.vue",
      }
    ],
  },
  {
    label: "Página Inicial",
    icon: "panorama",
    active: false,
    to: "/pagina_inicial_banner",
    submenu: [
      {
        label: "Banner Página Inicial",
        active: false,
        to: "/pagina_inicial_banner",
        componentName: "views/paginas/PaginaInicialBanner/ListaPaginaInicialBanner.vue",
      },
      {
        label: "Ordenação Banners Carrossel",
        active: false,
        to: "/ordenacao-banners",
        componentName: "views/paginas/configuracaoBanners/ConfiguracaoBanner.vue",
      },
      {
        label: "Ordenação Banners Fixo",
        active: false,
        to: "/ordenacao-banners-fixo",
        componentName: "views/paginas/configuracaoBanners/ConfiguracaoBannerFixo.vue",
      },
      {
        label: "Notícias",
        active: false,
        to: "/noticias",
        componentName: "views/paginas/noticias/ListaNoticias.vue",
      },
      {
        label: "Ordenação Notícias Tipo Imagem",
        active: false,
        to: "/ordenacao-noticia-tipo-imagem",
        componentName: "views/paginas/noticias/OrdenacaoTipoImagem.vue",
      },
      {
        label: "Ordenação Notícias Tipo Vídeo",
        active: false,
        to: "/ordenacao-noticia-tipo-video",
        componentName: "views/paginas/noticias/OrdenacaoTipoVideo.vue",
      },
      {
        label: "Ordenação Notícias Tipo Texto",
        active: false,
        to: "/ordenacao-noticia-tipo-texto",
        componentName: "views/paginas/noticias/OrdenacaoTipoTexto.vue",
      },
      {
        label: "Card de Notícias",
        active: false,
        to: "/cardnoticia",
        componentName: "views/paginas/cardNoticia/ListaCardNoticia.vue",
      },
    ]
  },
  {
    label: "Glossários",
    icon: "book",
    active: false,
    to: "/glossarios",
    componentName: "views/paginas/glossarios/ListaGlossarios.vue",
  },
  {
    label: "Municípios",
    icon: "building",
    active: false,
    to: "/municipio",
    componentName: "views/paginas/municipio/ListaMunicipios.vue",
  },
  {
    label: "Legislações",
    icon: "scale-balanced",
    active: false,
    to: "/legislacoes",
    componentName: "views/paginas/legislacoes/ListaLegislacoes.vue",
  },
  {
    label: "Sobre o Portal",
    icon: "circle-info",
    active: false,
    to: "/sobreoportal",
    componentName: "views/paginas/sobreoportal/ListaSobreOPortal.vue"
  },
  {
    label: "Acessibilidade",
    icon: "wheelchair",
    active: false,
    to: "/acessibilidade",
    componentName: "views/paginas/acessibilidade/ListaAcessibilidade.vue"
  },
  {
    label: "Estrutura Organizacional",
    icon: "sitemap",
    active: false,
    to: "/estrutura_organizacional",
    componentName: "views/paginas/estruturaOrganizacional/ListaEstruturaOrganizacional.vue"

  },
  {
    label: "Projetos Sociais",
    icon: "hands-holding-child",
    active: false,
    to: "/projetos_sociais",
    componentName: "views/paginas/projetosSociais/ListaProjetosSociais.vue"
  },
  {
    label: "Formulário de Informação ao Cidadão",
    icon: "file-lines",
    active: false,
    to: "/formulario_informacao_cidadao",
    componentName: "views/paginas/FormularioInformacaoCidadao/ListaFormularioInformacaoCidadao.vue"
  },
  {
    label: "Principais Cargos",
    icon: "list",
    active: false,
    to: "/cargo",
    submenu: [
      {
        label: "Cargos",
        active: false,
        to: "/cargos",
        componentName: "views/paginas/cargos/ListaCargo.vue"
      },
      {
        label: "Órgãos",
        active: false,
        to: "/orgaos",
        componentName: "views/paginas/orgaos/ListaOrgao.vue"
      },
      {
        label: "Pessoas",
        active: false,
        to: "/pessoas",
        componentName: "views/paginas/pessoas/ListaPessoa.vue"
      },
      {
        label: "Ordenação Cargos",
        active: false,
        to: "/ordenacao-cargos",
        componentName: "views/paginas/cargo/OrdenacaoCargo.vue"
      },
      {
        label: "Ordenação Órgãos",
        active: false,
        to: "/ordenacao-orgaos",
        componentName: "views/paginas/orgaos/OrdenacaoOrgao.vue"
      },
    ],
  },
  {
    label: "Acesso Informação",
    icon: "info",
    active: false,
    to: "/esic/create",
    submenu: [
      {
        label: "E-SIC",
        active: false,
        to: "/esic/create",
        componentName: "views/paginas/esic/AdicionaEsic.vue"
      },
      {
        label: "SIC Presencial",
        active: false,
        to: "/sicpresencial/create",
        componentName: "views/paginas/sicPresencial/AdicionaSicPresencial.vue"
      },
      {
        label: "Formulário",
        active: false,
        to: "/formulario/create",
        componentName: "views/paginas/formulario/AdicionaFormularioComponent.vue"
      },
    ],
  },
  {
    label: "Gerenciar Rodapé",
    icon: "bars",
    active: false,
    to: "/gerenciar-rodape/acesso-rapido",
    submenu: [
      {
        label: "Acesso Rápido",
        active: false,
        to: "/gerenciar-rodape/acesso-rapido",
        meta: {
          requiresAuth: true,
          roles: roles.adminOnly,
        },
        componentName: "views/paginas/gerenciarRodape/AcessoRapidoView.vue"
      },
      {
        label: "Rodapé",
        active: false,
        to: "/gerenciar-rodape/rodape-portal",
        meta: {
          requiresAuth: true,
          roles: roles.all,
        },
        componentName: "views/paginas/gerenciarRodape/rodapePortal/RodapePortalView.vue",
      },
    ],
  },
  {
    label: "Gestão de Documentos de Auditoria",
    icon: "file-lines",
    active: false,
    to: "/gestao-documentos-auditoria",
    name: "gestao-documentos-auditoria",
    componentName: "views/paginas/gestaoDocumentosAuditoria/ListaGestaoDocumentosAuditoria.vue",
  },
  {
    label: "Dados Abertos",
    icon: "database",
    active: false,
    to: "/dados-abertos/conjuntos",
    submenu: [
      {
        label: "Categorias dos Conjuntos",
        active: false,
        to: "/dados-abertos/categorias",
        componentName: "views/paginas/dadosAbertos/ListaDadosAbertosCategorias.vue",
      },
      {
        label: "Conjuntos de Dados",
        active: false,
        to: "/dados-abertos/conjuntos",
        componentName: "views/paginas/dadosAbertos/ListaDadosAbertosConjuntos.vue",
      },
      {
        label: "Recursos",
        active: false,
        to: "/dados-abertos/recursos",
        componentName: "views/paginas/dadosAbertos/ListaDadosAbertosRecursos.vue",
      },
    ],
  },
    {
        label: "Perguntas Frequentes",
        icon: "bars",
        active: false,
        to: "/perguntasfrequentes",
        submenu: [
            {
                label: "Perguntas",
                active: false,
                to: "/perguntasfrequentes",
                meta: {
                    requiresAuth: true,
                    roles: roles.adminAndEditorRepresentante,
                },
                componentName: "views/paginas/perguntasFrequentes/ListaPerguntasFrequentes.vue"
            },
            {
                label: "Assuntos",
                active: false,
                to: "/assuntos/",
                meta: {
                    requiresAuth: true,
                    roles: roles.adminAndEditorRepresentante,
                },
                componentName: "views/paginas/assuntos/ListaAssuntos.vue"
            },
        ],
    },
  {
    label: "Adminstração",
    icon: "user",
    active: false,
    to: "/usuarios",
    componentName: "views/paginas/usuarios/ListaUsuario.vue"
  },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/paginasEstaticas",
  //   name: "paginasEstaticas.index",
  //   componentName: "views/paginas/paginasEstaticas/ListaPaginasEstatica.vue"
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/menus",
  //   name: "menu.index",
  //   componentName: "views/paginas/menus/ListaMenus.vue"
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/paginainicialvideo",
  //   name: "paginainicialvideo.index",
  //   componentName: "views/paginas/paginaInicialVideo/ListaVideo.vue"
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/competencia",
  //   name: "competencia.index",
  //   componentName: () =>
  //       import("views/paginas/competencias/ListaCompetencias.vue"
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/horarioatendimento",
  //   name: "horarioatendimento.index",
  //   componentName: () =>
  //       import(
  //           "views/paginas/horariosatendimento/ListaHorariosAtendimento.vue"
  //
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/curriculos",
  //   name: "curriculos.index",
  //   componentName: "views/paginas/curriculos/ListaCurriculos.vue"),
  //   // beforeEnter:middleware.auth,
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/banners/",
  //   name: "banners.index",
  //   componentName: "views/paginas/banners/ListaBanner.vue"
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/certidao_estadual",
  //   name: "certidao_estadual.index",
  //   componentName: () =>
  //       import("views/paginas/certidaoEstadual/ListaCertidaoEstadual.vue"
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/links_google_drive",
  //   name: "links_google_drive.index",
  //   componentName: () =>
  //       import("views/paginas/linkGoogleDrive/ListaLinkGoogleDrive.vue"
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/acesso-a-informacao",
  //   name: "acesso-a-informacao.index",
  //   componentName: () =>
  //       import("views/paginas/acessoInformacao/ListaAcessoInformacao.vue"
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/cargo",
  //   name: "cargo.index",
  //   componentName: "views/paginas/cargo/ListaCargo.vue"
  //   props: true,
  // },
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/pessoa",
  //   name: "pessoa.index",
  //   componentName: "views/paginas/pessoa/ListaPessoa.vue"
  //   props: true,
  // },

  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/atendimentocidadao",
  //   name: "atendimentocidadao.index",
  //   componentName: "views/paginas/atendimentocidadao/ListaAtendimentoCidadao.vue"
  //   props: true,
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/atendimentocidadao/create",
  //   name: "atendimentocidadao.create",
  //   componentName: "views/paginas/atendimentocidadao/AdicionaAtendimentoCidadao.vue"
  //   props: true,
  // },
  // {
  //   label: "",
  //   icon: "",
  //   active: false,
  //   to: "/atendimentocidadao/:id/edit",
  //   name: "atendimentocidadao.edit",
  //   componentName: "views/paginas/atendimentocidadao/EditaAtendimentoCidadao.vue"
  //   props: true,
  // },

];
const menuItems = ref(menuItemsStatic);

export { menuItemsStatic, menuItems };
